import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import { AccountPopoverAccount } from '../shared/AccountPopover';
import { BakerTopNav } from './BakerTopNav';

const APP_BAR_MOBILE = 56;
const APP_BAR_DESKTOP = 64;

const RootStyle = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%'
});

// Full-width content under the fixed menu bar. Top-level navigation lives in the
// bar (no global sidebar), so pages get the entire screen width; an individual
// page may still render its own in-page sidebar.
const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 16,
  paddingBottom: theme.spacing(10),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 16,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  }
}));

type BakerDashboardLayoutProps = {
  /** Signed-in Entra account (email + sign-out) for the shared AccountPopover. */
  account?: AccountPopoverAccount;
};

export function BakerDashboardLayout({ account }: BakerDashboardLayoutProps = {}) {
  return (
    <RootStyle>
      <BakerTopNav account={account} />
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
